import { request } from "#/utils/request";

interface IGetVendasBoleto {
  idDocumento: number;
  codigoComissionado: string;
  documento: string;
}

export interface IGetVendasBoletoData {
  data: Data;
  errors: Errors;
}

interface Data {
  billId: number;
  identifierId: number;
  barCode: string;
  dueDate: string;
  billValue: number;
  typeableLine: string;
  bill: string;
}

interface Errors {
  message: string;
  code: number;
}

export const getVendasBoleto = async ({
  idDocumento,
  codigoComissionado,
  documento,
}: IGetVendasBoleto) =>
  (
    await request.get<IGetVendasBoletoData>(
      `/vendas/boleto?idDocumento=${idDocumento}&codigoComissionado=${codigoComissionado}&documento=${documento}`,
      {}
    )
  ).data;
